import { getContext, setContext } from 'svelte'

import { preloadData, pushState, goto, beforeNavigate, afterNavigate, invalidateAll, onNavigate } from '$app/navigation'
import { page } from '$app/state'
import { getPageStateContext, PageStateContext } from './PageStateContext.svelte'
import { ResultSync } from '$lib/utils/result'
import { browser } from '$app/environment'

const CONTEXT = Symbol('TAILWIND')

export function createBreakpointContext(): BreakpointContext {
      return setContext(CONTEXT, new BreakpointContext())
}

export function getBreakpointContext(): BreakpointContext {
      return getContext(CONTEXT)
}

class BreakpointContext {
      breakpoint: string = $state('')
      breakpointNumber: number = $state(2)
      portrait: boolean = $state(false)

      constructor() {
            this.getBreakpoint()
            this.isPortrait()
            return this
      }

      getBreakpoint() {
            if (!browser) return
            let styles = getComputedStyle(document.documentElement)
            let breakpoint = styles.getPropertyValue('--breakpoint')
            if (this.breakpoint != breakpoint) {
              this.breakpoint = breakpoint
              this.breakpointNumber = this.getBreakpointNumber()
            }
            return this
      }

      isPortrait() {
        if( ! browser ) return
        const portrait = window.screen.orientation.type.match(/portrait/)
        if( !! portrait != this.portrait ) this.portrait = !! portrait
        return this
      }

      getBreakpointNumber() {
        return ["base", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl", "5xl"].indexOf(this.breakpoint)
      }
}
